import { createTheme } from "@mui/material/styles";

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: "#0B1F36",
      light: "#1B3553",
      dark: "#071526",
    },
    secondary: {
      main: "#4682B4",
      light: "#B0C4DE",
      dark: "#2C5F8A",
    },
    background: {
      default: '#0A1626',
      paper: '#0F1E33',
    },
    divider: '#22314a',
    text: {
      primary: "#F8FBFF",
      secondary: "#C3CBD6",
    },
  },
  shape: {
    borderRadius: 2,
  },
  typography: {
    fontFamily: '"Jost", "Roboto", "Helvetica", "Arial", sans-serif',
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    h1: {
      fontFamily: '"Playfair Display", serif',
      letterSpacing: '-0.02em',
      fontWeight: 700,
    },
    h2: {
      fontFamily: '"Playfair Display", serif',
      letterSpacing: '-0.01em',
      fontWeight: 500,
    },
    h3: {
      fontFamily: '"Playfair Display", serif',
      fontWeight: 500,
    },
    h4: {
      fontFamily: '"Playfair Display", serif',
      fontWeight: 500,
    },
    h5: {
      fontFamily: '"Playfair Display", serif',
      fontWeight: 500,
    },
    h6: {
      fontFamily: '"Playfair Display", serif',
      fontWeight: 600,
    },
    button: {
      textTransform: "none",
      fontWeight: 600,
      fontFamily: '"Jost", sans-serif',
      letterSpacing: '0.02em',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 0,
          fontWeight: 600,
        },
        contained: {
          boxShadow: "0 6px 16px rgba(10, 22, 38, 0.25)",
          "&:hover": {
            boxShadow: "0 10px 24px rgba(10, 22, 38, 0.35)",
            transform: "translateY(-1px)",
          },
        },
        outlined: {
          borderWidth: 1,
          "&:hover": {
            borderWidth: 1,
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: "none",
          backgroundColor: "rgba(8,21,36,0.92)",
          backdropFilter: "blur(16px)",
          borderBottom: "1px solid rgba(176,196,222,0.1)",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
          borderRadius: 0,
          border: "1px solid rgba(70,130,180,0.12)",
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 0,
          fontWeight: 500,
        },
      },
    },
  },
});

const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: "#0B1F36",
      light: "#1B3553",
      dark: "#071526",
    },
    secondary: {
      main: "#4682B4",
      light: "#B0C4DE",
      dark: "#2C5F8A",
    },
    background: {
      default: '#F2F7FC',
      paper: '#FFFFFF',
    },
    divider: 'rgba(70,130,180,0.12)',
    text: {
      primary: "#1B2430",
      secondary: "#3D4A57",
    },
  },
  shape: {
    borderRadius: 2,
  },
  typography: {
    fontFamily: '"Jost", "Roboto", "Helvetica", "Arial", sans-serif',
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    h1: {
      fontFamily: '"Playfair Display", serif',
      letterSpacing: '-0.02em',
      color: '#1B2430',
      fontWeight: 700,
    },
    h2: {
      fontFamily: '"Playfair Display", serif',
      letterSpacing: '-0.01em',
      color: '#1B2430',
      fontWeight: 500,
    },
    h3: {
      fontFamily: '"Playfair Display", serif',
      color: '#1B2430',
      fontWeight: 500,
    },
    h4: {
      fontFamily: '"Playfair Display", serif',
      color: '#1B2430',
      fontWeight: 500,
    },
    h5: {
      fontFamily: '"Playfair Display", serif',
      fontWeight: 500,
      color: '#1B2430',
    },
    h6: {
      fontFamily: '"Playfair Display", serif',
      fontWeight: 600,
      color: '#1B2430',
    },
    button: {
      textTransform: "none",
      fontWeight: 600,
      fontFamily: '"Jost", sans-serif',
      letterSpacing: '0.02em',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          borderRadius: 0,
          fontWeight: 600,
        },
        contained: {
          boxShadow: "0 6px 16px rgba(10, 22, 38, 0.25)",
          "&:hover": {
            boxShadow: "0 10px 24px rgba(10, 22, 38, 0.35)",
            transform: "translateY(-1px)",
          },
        },
        outlined: {
          borderWidth: 1,
          "&:hover": {
            borderWidth: 1,
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: "none",
          backgroundColor: "rgba(8,21,36,0.92)",
          backdropFilter: "blur(16px)",
          borderBottom: "1px solid rgba(176,196,222,0.1)",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
          backgroundColor: '#FFFFFF',
          borderRadius: 0,
          border: "1px solid rgba(70,130,180,0.12)",
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 0,
          fontWeight: 500,
        },
      },
    },
  },
});

export { darkTheme, lightTheme };
export default darkTheme;
